import React from "react";

export default function PaginationLayout({
  index,       // Current Page (Number)
  totalpages,  // Total Number of Pages (Number)
  setindex,    // State Setter
}: any) {
  const currentPage = Number(index);
  const total = Number(totalpages);
  const range = 3; // Number of page buttons to show

  // --- Sliding Window Logic ---
  let startPage: number;
  let endPage: number;

  if (total <= range) {
    startPage = 1;
    endPage = total;
  } else {
    // Calculate mid-point of the range
    const sideButtons = Math.floor(range / 2);
    
    if (currentPage <= sideButtons) {
      startPage = 1;
      endPage = range;
    } else if (currentPage + sideButtons >= total) {
      startPage = total - range + 1;
      endPage = total;
    } else {
      startPage = currentPage - sideButtons;
      endPage = currentPage + sideButtons;
    }
  }

  // Helper to change page safely
  const handlePageChange = (newPage: number) => {
    if (newPage >= 1 && newPage <= total) {
      setindex(newPage);
    }
  };

  if (total <= 1) return null; // Don't show pagination if there's only 1 page

  return (
    <>
      <p>Total page: {total}</p>
      <div className="paginating-container pagination-solid">
        <ul className="pagination">
          
          {/* Jump Back 3 */}
          {currentPage > 3 && (
            <li className="prev pointer" onClick={() => handlePageChange(currentPage - 3)}>
              <i className="fas fa-angle-double-left"></i>
            </li>
          )}

          {/* Previous Page */}
          {currentPage > 1 && (
            <li className="prev pointer" onClick={() => handlePageChange(currentPage - 1)}>
              <i className="fas fa-chevron-left"></i>
            </li>
          )}

          {/* Numerical Pages */}
          {Array.from(
            { length: endPage - startPage + 1 },
            (_, i) => startPage + i
          ).map((n) => (
            <li
              key={n}
              className={currentPage === n ? "pointer active" : "pointer"}
              onClick={() => handlePageChange(n)}
            >
              <a href="#!">{n}</a>
            </li>
          ))}

          {/* Next Page */}
          {currentPage < total && (
            <li className="next pointer" onClick={() => handlePageChange(currentPage + 1)}>
              <i className="fas fa-chevron-right"></i>
            </li>
          )}

          {/* Jump Forward 3 */}
          {currentPage <= total - 3 && (
            <li className="next pointer" onClick={() => handlePageChange(currentPage + 3)}>
              <i className="fas fa-angle-double-right"></i>
            </li>
          )}
          
        </ul>
      </div>
    </>
  );
}